import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 2rem 2rem 3.6rem 2rem;

  ${({ theme }) => theme.media.tablet`
  padding: 2rem 3.6rem 3.6rem 3.6rem;

  `};
`;

export const BankOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1.2rem;
  margin-top: 1.6rem;
`;
